import React from 'react';
import { ConfigProvider } from 'antd';
import ptPT from 'antd/locale/pt_PT';
import enUS from 'antd/locale/en_US';
import { useTranslation } from 'react-i18next';

const ptLocale = {
  ...ptPT,
  Pagination: {
    ...ptPT.Pagination,
    items_per_page: '/ página',
    jump_to: 'Saltar',
    jump_to_confirm: 'confirmar',
    page: 'Página',
    prev_page: 'Página Anterior',
    next_page: 'Página Seguinte',
    prev_5: 'Recuar 5 Páginas',
    next_5: 'Avançar 5 Páginas',
    prev_3: 'Recuar 3 Páginas',
    next_3: 'Avançar 3 Páginas',
    page_size: 'dimensão da página',
  },
};

const LocaleProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const { i18n } = useTranslation();
  return (
    <ConfigProvider locale={i18n.language === 'en' ? enUS : ptLocale}>
      {children}
    </ConfigProvider>
  );
};

export default LocaleProvider;
